import {
  DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_BEGIN,
  DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_SUCCESS,
  DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_FAILURE,
  DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function updateCollectionWithMySql(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_BEGIN,
    });

    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/mysql/update-collection`,
        args,
        header,
      );

      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_SUCCESS,
            data: res,
          });
          Mixpanel.track('Updated Collection from MySQL data source', {
            uuid: res.data.uuid,
            collectionName: res.data.collectionName,
          });
          toast.success('Collection updated successfully!');
          resolve(res);
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          Mixpanel.track('Failed to update collection from MySQL data source');
          dispatch({
            type: DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateCollectionWithMySqlError() {
  return {
    type: DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateCollectionWithMySqlPending: true,
        updateCollectionWithMySqlError: null,
      };

    case DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_SUCCESS:
      // The request is success
      return {
        ...state,
        updateCollectionWithMySqlPending: false,
        updateCollectionWithMySqlError: null,
      };

    case DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_FAILURE:
      // The request is failed
      return {
        ...state,
        updateCollectionWithMySqlPending: false,
        updateCollectionWithMySqlError: action.data.error,
      };

    case DATA_CONNECTOR_UPDATE_COLLECTION_WITH_MY_SQL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateCollectionWithMySqlError: null,
      };

    default:
      return state;
  }
}
